module.exports = __webpack_public_path__ + "static/media/manage-auctions.bd2b4832.svg";